import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { getAuth, sendPasswordResetEmail } from "firebase/auth"
import {toast} from 'react-toastify'
import {ReactComponent as ArrowRightIcon} from '../assets/svg/keyboardArrowRightIcon.svg'
import '../Styles/SignUp.css'
import '../Styles/button.css'

function ForgotPassword() {
  const navigate = useNavigate() 
  const [email, setEmail] = useState('')
  const onChange = (e) => setEmail(e.target.value)

  const onSubmit = async (e) => {
    e.preventDefault()
    try {
      const auth = getAuth()
      await sendPasswordResetEmail(auth, email)
      toast.success('Email was send')
    } catch (error) {
      toast.error('Could not send reset email')
    }
  }
  const onRedirect = () => {
    navigate('/sign-in')
  }
  return (
    <div className="sign-up-container container">
      <header>
        <h1 className="main-header">Glemt Kode</h1>
      </header>
      <main>
        <form onSubmit={onSubmit}>
          <input 
          type='email'
          className="emailInput border"
          placeholder="Email"
          id='email'
          value={email}
          onChange={onChange}
          />
          <div className="d-flex justify-content-center mb-2">
              <button className="generic-ea-btn">
                Send Mail
              </button>
              </div>
        </form>
        <div className="d-flex justify-content-center">
          <button className="redirect-btn" onClick={onRedirect}>
            Tilbage
          </button>
          </div>
      </main>
    </div>
  )
}

export default ForgotPassword